export default function asNumber(value: string) {
  if (value.endsWith('.')) {
    // "3." can't really be considered a number even if it parses in js. The
    // user is most likely entering a float.
    return value;
  }

  if (value.endsWith('.0')) {
    // We need to return this as a string here, to allow for input like 3.07
    return value;
  }

  const n = Number(value);
  const valid = typeof n === 'number' && !Number.isNaN(n);
  return valid ? n : value;
}
